import React from 'react'
import { useStyles } from './styles.js'

const ProgramFileLogo = (props) => {
  const classes = useStyles()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49.806"
      height="60.733"
      viewBox="0 0 49.806 60.733"
      className={classes.ProgramFileLogo}
    >
      <g transform="translate(-238 6.805)">
        <g transform="translate(238 -6.805)">
          <g transform="translate(0 0)">
            <path
              class="a"
              d="M14.392,58.555V49.937H47.975a1.188,1.188,0,0,0,1.189-1.187V32.59A1.188,1.188,0,0,0,47.975,31.4H14.392V2.569H44.617V13.174a1.188,1.188,0,0,0,1.189,1.187H56.429V58.555ZM11.377,33.776H46.786V47.563H11.377ZM46.995,4.247l7.753,7.741H46.995ZM58.8,13.134c0-.013,0-.027,0-.04a1.2,1.2,0,0,0-.019-.151h0a1.189,1.189,0,0,0-.041-.148l-.013-.037a1.226,1.226,0,0,0-.059-.133l0-.009a1.185,1.185,0,0,0-.082-.13l-.024-.032a1.174,1.174,0,0,0-.1-.117l0,0L46.647.543h0a1.2,1.2,0,0,0-.118-.1L46.495.416a1.194,1.194,0,0,0-.13-.082l-.008,0a1.169,1.169,0,0,0-.134-.059L46.186.259a1.184,1.184,0,0,0-.3-.06l-.039,0-.041,0H13.2a1.188,1.188,0,0,0-1.189,1.187V31.4H10.189A1.188,1.188,0,0,0,9,32.59V48.75a1.188,1.188,0,0,0,1.189,1.187h1.826v9.8A1.188,1.188,0,0,0,13.2,60.928H57.617a1.188,1.188,0,0,0,1.189-1.187V13.175c0-.013,0-.027,0-.04Zm-34.948,26.9a1.086,1.086,0,0,1-.718.2H21.883V38.594h1.255q.951,0,.951.826a.768.768,0,0,1-.233.617m-.48-2.763H20.942a.73.73,0,0,0-.808.807v5.08a.8.8,0,0,0,.865.864.884.884,0,0,0,.647-.233.843.843,0,0,0,.238-.631V41.547h1.493a2.462,2.462,0,0,0,1.726-.57,2.294,2.294,0,0,0,0-3.138,2.473,2.473,0,0,0-1.731-.565m7.27,4.809a2.022,2.022,0,0,1-1.469.479h-.856V38.68h.856a2.035,2.035,0,0,1,1.469.475,2.435,2.435,0,0,1,0,2.929m.571-4.405a4.228,4.228,0,0,0-1.916-.4H27.38a.73.73,0,0,0-.808.807v5.08a.73.73,0,0,0,.808.807H29.3a4.292,4.292,0,0,0,1.926-.4,2.792,2.792,0,0,0,1.227-1.154,3.624,3.624,0,0,0,.423-1.8,3.542,3.542,0,0,0-.428-1.785,2.857,2.857,0,0,0-1.231-1.154m6.709.964a1,1,0,0,0,.623-.161.614.614,0,0,0,.2-.513.647.647,0,0,0-.2-.527.973.973,0,0,0-.628-.166h-3.2a.73.73,0,0,0-.808.807v5.08a.862.862,0,1,0,1.721,0V41.243h2.092a1,1,0,0,0,.623-.161.614.614,0,0,0,.2-.513.643.643,0,0,0-.2-.522.956.956,0,0,0-.623-.171H35.643V38.642Z"
              transform="translate(-9 -0.195)"
              fill="#F37320"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ProgramFileLogo
